import { render, staticRenderFns } from "./ServersList.vue?vue&type=template&id=9b7d4b96&scoped=true&"
import script from "./ServersList.vue?vue&type=script&lang=js&"
export * from "./ServersList.vue?vue&type=script&lang=js&"
import style0 from "./ServersList.vue?vue&type=style&index=0&id=9b7d4b96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b7d4b96",
  null
  
)

component.options.__file = "ServersList.vue"
export default component.exports